import { defineComponent as _defineComponent } from 'vue'
import NotFoundComponent from "@/components/NotFound.vue";
import { MetadataKeys } from "@/types";
import { onMounted, ref } from "vue";
import { useViewAnalytics } from "@/composition/useViewAnalytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundPage',
  setup(__props) {

const pageName = ref("Error");
const { pageTitle, setAnalyticsMetadata, pushPageViewEvent } =
  useViewAnalytics(pageName);

onMounted(() => {
  setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Error Page");
  setAnalyticsMetadata(MetadataKeys.SITESECTION, "AlmanacPlus");
  pushPageViewEvent();
});

return { __sfc: true,pageName, pageTitle, setAnalyticsMetadata, pushPageViewEvent, NotFoundComponent }
}

})